import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren, useMemo } from 'react';

export interface AlertProps {
  // other variants not implemented yet
  variant?: 'soft';
  colour?: 'green' | 'red' | 'yellow' | 'blue';
  className?: string;
  iconName?: TIconName;
}

const Alert: FC<PropsWithChildren<AlertProps>> = (props) => {
  const { colour = 'green', className, children } = props;

  const colourClasses = useMemo(() => {
    switch (colour) {
      case 'blue':
        return 'bg-blue-100 border border-blue-200 text-blue-800 dark:bg-blue-800/10 dark:border-blue-900 dark:text-blue-500';
      case 'green':
        return 'bg-green-100 border border-green-200 text-green-800 dark:bg-green-800/10 dark:border-green-900 dark:text-green-500';
      case 'red':
        return 'bg-red-100 border border-red-200 text-red-800 dark:bg-red-800/10 dark:border-red-900 dark:text-red-500';
      case 'yellow':
        return 'bg-yellow-100 border border-yellow-200 text-yellow-800 dark:bg-yellow-800/10 dark:border-yellow-900 dark:text-yellow-500';
    }
  }, [colour]);

  return (
    <div
      className={clstx(
        'typography:prose rounded-lg p-4 text-base',
        colourClasses,
        className
      )}
      role="alert"
    >
      <div className="flex flex-row items-start">
        {props.iconName && (
          <UntitledIcon
            name={props.iconName}
            className="mr-4 h-6 w-6 shrink-0"
          />
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Alert;
